module.exports = __webpack_public_path__ + "img/paystack-blue.8eb73af1.svg";